<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Importar Archivo</p>
    </header>
    <section class="modal-card-body">
      <b-field>
        <b-upload v-model="dropFiles" multiple drag-drop :loading="loadingUpload">
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"> </b-icon>
              </p>
              <p>Arrastra y suelta tu archivo aqui o da click para subir</p>
            </div>
          </section>
        </b-upload>
      </b-field>

      <div class="tags">
        <span
          v-for="(file, index) in dropFiles"
          :key="index"
          class="tag is-primary"
        >
          {{ file.name }}
          <button
            class="delete is-small"
            type="button"
            @click="deleteDropFile(index)"
          ></button>
        </span>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cerrar
      </button>
      <button
        :disabled="!dropFilesExist"
        @click="goSaveImport"
        class="button is-primary"
      >
        Importar
      </button>
    </footer>
  </div>
</template>

<script>
import SociosApi from "../../api/modules/SociosApi";
export default {
  props: ['material','loadItemMateriales'],
  data() {
    return {
      dropFiles: [],
      loadingUpload:false
    };
  },
  computed: {
    dropFilesExist() {
      return this.dropFiles.length > 0;
    },
  },
  methods: {
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },

    goSaveImport() {
       return new Promise((resolve, reject) => {
         SociosApi.importItemMaterialMasivo(this, {
           idClient: this.material.idClient,
           idMaterial: this.material.idMaterial,
           idOrderMaterial:this.material.idOrderMaterial,
           code:this.material.code,
           file: this.dropFiles[0],
        })
           .then((data) => {
             this.loadItemMateriales();
             resolve(data);
             this.$emit('close')
           })
           .catch((error) => {
             reject(error);
           });
       });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal/ImportarArchivo.vue